import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import {
  ChangeReleaseInputField,
} from '@webapp/store/release/action-creators';
import {
  RELEASE_ON_CHANGE_INPUT_FIELD,
} from '@webapp/store/release/actions';
import AppState from '../../../state';
import {
  fieldToIndexMap,
  fieldToStepIndexMap,
  releaseStepNameFromIndexMap,
} from '@webapp/utils/release/constants';
import { rudderTrack } from '@webapp/utils/rudderstack/init';
import { Action } from 'redux';

export const trackReleaseInputFieldUpdated = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, ChangeReleaseInputField<any>>(
      RELEASE_ON_CHANGE_INPUT_FIELD
    ),
    withLatestFrom(state$),
    map(([action, state]) => {
      const fieldIndex = fieldToIndexMap[action.field];
      const stepIndex = fieldToStepIndexMap[action.field];
      const stepName = releaseStepNameFromIndexMap[stepIndex];
      if (window.analytics && action.value) {
        window.analytics.track('Release Updated', {
          releaseId: state.release.release?.id,
          field_name: action.field,
          field_value: action.value,
          ...(typeof stepIndex !== 'undefined' && { stepIndex }),
        });
      }
      rudderTrack('Release Step Completed', {
        artist_id: state.artist.active?.id,
        artist_name: state.artist.active?.name,
        step_index: stepIndex,
        step_name: stepName,
        release_id: state.release.release?.id,
        release_name: state.release.release?.title,
        field_index: fieldIndex,
        field_name: action.field,
        field_value: action.value,
        track_index: undefined,
      });
    }),
    filter(() => false)
  );
